/**
 * Embedded Dashboard - Full dashboard view for UMT-HUD iframe
 *
 * This page is loaded when AutoTask-Hub is embedded in Mission Control HUD.
 * It shows the full Dashboard component (same as the main page).
 *
 * Route: /embedded (anonymous in staticwebapp.config.json)
 * Security: CSP frame-ancestors limits which domains can embed this page
 */

import Dashboard from './Dashboard';

export default function Embedded() {
  // Just render the full Dashboard - same experience as the main page
  return <Dashboard />;
}
